// src/features/october/hooks/useProductFilters.js
import { useState, useMemo } from 'react';

export const useProductFilters = () => {
  const [filters, setFilters] = useState({
    category: 'all',
    gender: 'all',
    type: 'all',
    intensity: 'all',
    season: 'all',
    priceRange: [0, 1000],
    inStock: false,
    featured: false
  });

  // Update individual filter
  const updateFilter = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Update multiple filters at once
  const updateFilters = (newFilters) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters
    }));
  };

  // Reset all filters
  const resetFilters = () => {
    setFilters({
      category: 'all',
      gender: 'all',
      type: 'all',
      intensity: 'all',
      season: 'all',
      priceRange: [0, 1000],
      inStock: false,
      featured: false
    });
  };

  // Check if any filters are active
  const hasActiveFilters = useMemo(() => {
    return filters.category !== 'all' ||
           filters.gender !== 'all' ||
           filters.type !== 'all' ||
           filters.intensity !== 'all' ||
           filters.season !== 'all' ||
           filters.priceRange[0] !== 0 ||
           filters.priceRange[1] !== 1000 ||
           filters.inStock ||
           filters.featured;
  }, [filters]);

  return {
    filters,
    updateFilter,
    updateFilters,
    resetFilters,
    hasActiveFilters
  };
};